import { INavData } from '@coreui/angular';


export const navItemsMsal: INavData[] = [
  {
    name: 'Ventas Diarias',
    url: '/home/registro/VentasDiarias',
    icon: 'icon-list',
    children: [
      {
        name: 'Eventos',
        url: '/home/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: ''
        }
      },
      {
        name: 'Registro Ventas',
        url: '/home/registro/RegistroVentas',
        icon: 'icon-note'
      },
      {
        name: 'Consulta Ventas',
        url: '/home/registro/ConsultaVentas',
        icon: 'icon-magnifier'
      },
      {
        name: 'Monitor Ventas',
        url: '/home/registro/MonitorVentas',
        icon: 'icon-chart'
      },
      {
        name: 'Reporte Marca',
        url:'/home/registro/ReporteMarca',
        icon: 'icon-chart'
      },
      {
        name: 'Reporte Excel',
        url: '/home/registro/Reporte',
        icon: 'icon-chart'
      }
    ]
  },
  {
    name: 'Ventas Certificadas',
    url: '/home/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Reporte Marca',
        url:'/home/registro/ReporteMarca',
        icon: 'icon-chart'
      },
      {
        name: 'Registro Ventas Certificadas',
        url: '/home/registro/RegistroVentasCertificadas',
        icon: 'icon-note'
      },
      {
        name: 'Consultar Ventas Certificadas',
        url: '/home/registro/Consultarventacertificada',
        icon: 'icon-note'
      },
      {
        name: 'Monitor Ventas Certificadas',
        url: '/home/registro/MonitorVentasCertificadas',
        icon: 'icon-chart'
      },
      {
        name: 'Reporte Ventas Certificadas',
        url: '/home/registro/ReporteVentasCertificadas',
        icon: 'icon-chart'
      },
      {
        name: 'Informe Ventas Certificadas',
        url: '/home/registro/InformeVentasCertificadas',
        icon: 'icon-chart'
      },
      {
        name: 'Condiciones movimientos',
        url: '/home/registro/CondicionesMovimientos',
        icon: 'icon-chart'
      }
      
    ]
  },
  {
    name: 'Administrar',
    url: '/home/#',
    icon: 'icon-note',
    children: [
      {
        name: 'Usuarios',
        url: '/home/registro/AdmUsuario',
        icon: 'icon-user'
      },
      {
        name: 'Planes',
        url: '/home/registro/AdmUsuario',
        icon: 'icon-chart'
      },
    ]
  },
  {
    name: 'Reportes Converzion',
    url: '/home/registro/ReporteConverzion',
    icon: 'icon-list',
    children: [
      {
        name: 'General',
        url: '/home/registro/GeneralMM',
        icon: 'icon-chart'
      },
      {
        name: 'Centro Comercial',
        url: '/home/registro/CecoMM',
        icon: 'icon-chart'
      },
      {
        name: 'Geográfico',
        url: '/home/registro/ReporteGeografico',
        icon: 'icon-location-pin'
      },
      {
        name: 'Reporte Marca',
        url: '/home/registro/MarcaGral',
        icon: 'icon-chart'
      }
    ]
  }
];
export const navItemsDB: INavData[] = [
  {
    name: 'Ventas Diarias',
    url: '/home/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Eventos',
        url: '/inicio/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: ''
        }
      },
      {
        name: 'Registro Ventas',
        url: '/inicio/registro/RegistroVentas',
        icon: 'icon-note'
      },
      {
        name: 'Consulta Ventas',
        url: '/inicio/registro/ConsultaVentas',
        icon: 'icon-magnifier'
      }
    ]
  }
 ];
 export const navItemsReporte : INavData[] = [
  {
    name: 'Ventas Diarias',
    url: '/home/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Eventos',
        url: '/inicio/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: ''
        }
      },
      {
        name: 'Registro Ventas',
        url: '/inicio/registro/RegistroVentas',
        icon: 'icon-note'
      },
      {
        name: 'Consulta Ventas',
        url: '/inicio/registro/ConsultaVentas',
        icon: 'icon-magnifier'
      }
    ]
  }
 ];
 export const navItemsMixVentas: INavData[] = [
  {
    name: 'Ventas Diarias',
    url: '/home/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Eventos',
        url: '/inicio/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: ''
        }
      },
      {
        name: 'Registro Ventas',
        url: '/inicio/registro/RegistroVentas',
        icon: 'icon-note'
      },
      {
        name: 'Consulta Ventas',
        url: '/inicio/registro/ConsultaVentas',
        icon: 'icon-magnifier'
      }
    ]
  },{
    name: 'Ventas Certificadas',
    url: '/inicio/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Registro Ventas Certificadas',
        url: '/inicio/registro/RegistroVentasCertificadas',
        icon: 'icon-note'
      },
      {
        name: 'Consultar Ventas Certificadas',
        url: '/inicio/registro/Consultarventacertificada',
        icon: 'icon-note'
      }
    ]
  }
 ];
 export const navItemsCertificadaDB: INavData[] = [
  {
    name: 'Ventas Certificadas',
    url: '/inicio/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Registro Ventas Certificadas',
        url: '/inicio/registro/RegistroVentasCertificadas',
        icon: 'icon-note'
      },
      {
        name: 'Consultar Ventas Certificadas',
        url: '/inicio/registro/Consultarventacertificada',
        icon: 'icon-note'
      }
    ]
  }
 ];
 export const navItemsPactia: INavData[] = [
  {
    name: 'Ventas Diarias',
    url: '/home/registro/VentasCertificadas',
    icon: 'icon-list',
    children: [
      {
        name: 'Eventos',
        url: '/inicio/dashboard',
        icon: 'icon-speedometer',
        badge: {
          variant: 'info',
          text: ''
        }
      },
      {
        name: 'Registro Ventas',
        url: '/inicio/registro/RegistroVentas',
        icon: 'icon-note'
      },
      {
        name: 'Consulta Ventas',
        url: '/inicio/registro/ConsultaVentas',
        icon: 'icon-magnifier'
      },
      {
        name: 'Monitor Ventas',
        url: '/inicio/registro/MonitorVentas',
        icon: 'icon-chart'
      }
    ]
  }
 ];

